import Chart from "chart.js";

Chart.plugins.register({
  afterDraw: function (chart) {
    if (
      chart.data.datasets.length === 0 ||
      chart.data.datasets[0].data.length === 0
    ) {
      // No data is present
      var ctx = chart.chart.ctx;
      var width = chart.chart.width;
      var height = chart.chart.height;
      chart.clear();

      ctx.save();
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.font = "normal 56px arial";
      ctx.fillStyle = "#888";
      ctx.fillText("No Data", width / 2, height / 2);
      ctx.restore();
    }
  },
});

export function overall(url) {
  if ($("#overall").hasClass("chartjs-render-monitor")) {
    return;
  }

  $.getJSON(url).done(function (data) {
    new Chart($("#overall")[0], {
      type: "bar",
      data: {
        labels: data.male.map(function (e, i) {
          return e[0];
        }),
        datasets: [
          {
            label: "Male",
            backgroundColor: "#01C7FF",
            data: data.male.map(function (e, i) {
              return e[1];
            }),
          },
          {
            label: "Female",
            backgroundColor: "#FF90C7",
            data: data.female.map(function (e, i) {
              return e[1];
            }),
          },
        ],
      },
      options: {
        scales: {
          yAxes: [
            {
              stacked: true,
              ticks: { padding: 10, fontColor: " #000", fontSize: 14 },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Age Ranges",
                fontColor: " #000",
                fontSize: 14,
              },
              stacked: true,
              gridLines: false,
              ticks: {
                padding: 10,
                fontColor: " #000",
                fontSize: 14,
              },
            },
          ],
        },
        legend: { display: true },
        title: {
          fontSize: 18,
          fontColor: "#000",
          display: true,
          text: "Age and Gender Profile of Your Listeners",
        },
      },
    });
  });
}

export function likes(url) {
  if ($("#likes").hasClass("chartjs-render-monitor")) {
    return;
  }

  $.getJSON(url).done(function (data) {
    new Chart($("#likes")[0], {
      type: "bar",
      data: {
        labels: data.male.map(function (e, i) {
          return e[0];
        }),
        datasets: [
          {
            label: "Male",
            backgroundColor: "#01C7FF",
            data: data.male.map(function (e, i) {
              return e[1];
            }),
          },
          {
            label: "Female",
            backgroundColor: "#FF90C7",
            data: data.female.map(function (e, i) {
              return e[1];
            }),
          },
        ],
      },
      options: {
        scales: {
          yAxes: [
            {
              stacked: true,
              ticks: { padding: 10, fontColor: " #000", fontSize: 14 },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Age Ranges",
                fontColor: " #000",
                fontSize: 14,
              },
              stacked: true,
              gridLines: false,
              ticks: {
                padding: 10,
                fontColor: " #000",
                fontSize: 14,
              },
            },
          ],
        },
        legend: { display: true },
        title: {
          fontSize: 18,
          fontColor: "#000",
          display: true,
          text: "Age and Gender Profile of Your Fans",
        },
      },
    });
  });
}

export function heatmap(url) {
  if ($("#heatmap").hasClass("chartjs-render-monitor")) {
    return;
  }

  $.getJSON(url).done(function (data) {
    new Chart($("#heatmap")[0], {
      type: "bar",
      data: {
        labels: data.map(function (e, i) {
          return e[0];
        }),
        datasets: [
          {
            label: "",
            backgroundColor: data.map(function (e, i) {
              return e[0][0] == "M" ? "#01C7FF" : "#FF90C7";
            }),
            data: data.map(function (e, i) {
              return e[1];
            }),
          },
        ],
      },
      options: {
        padding: 10,
        scales: {
          yAxes: [{ display: false }],
          xAxes: [
            { gridLines: false, ticks: { padding: 10, fontColor: " #000" } },
          ],
        },
        legend: { display: false },
        title: {
          fontSize: 18,
          fontColor: "#000",
          display: true,
          text: "Probability that different Age/Gender groups like your music",
        },
      },
    });
  });
}

export function wax(url) {
  $.getJSON(url).done(function (data) {
    new Chart($("#fan_overlap_chart")[0], {
      type: "horizontalBar",
      data: {
        labels: data.map(function (e, i) {
          return e[0];
        }),
        datasets: [
          {
            label: "",
            backgroundColor: "#90C690",
            data: data.map(function (e, i) {
              return e[1];
            }),
          },
        ],
      },
      options: {
        padding: 10,
        scales: {
          yAxes: [
            {
              barThickness: 18,
              gridLines: false,
              ticks: { padding: 10, fontColor: " #000" },
            },
          ],
          xAxes: [{ ticks: { padding: 10, fontColor: " #000" } }],
        },
        legend: { display: false },
        title: {
          fontSize: 22,
          fontColor: "#000",
          display: true,
          text: "Fan Overlap Report",
        },
      },
    });
  });
}
